import React, { useState } from 'react'
import { toast } from "react-toastify";
import { decryptId } from '../../../Utils/Crypto';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { factCheckPostApi } from '../../../Services/FactCheck/factCheck';

const FactCheck = () => {
    const dispatch = useDispatch();
    const [factText, setFactText] = useState("");
    const [isFactCheckModalOpen, setIsFactCheckModalOpen] = useState(false);
    const { encryptedId } = useParams();
    const id = decryptId(encryptedId);

    const handleFactCheckSubmit = async (event) => {
        event.preventDefault();

        if (factText.trim() === "") {
            toast.error("Please enter some text before submitting.");
            return;
        }

        // Create a FormData object
        const formData = new FormData();
        formData.append("fact_check", factText);
        formData.append("community", id); // Make sure id is available

        try {
            const result = await dispatch(factCheckPostApi(formData)).unwrap();
            if (result?.status === 200) {
                setFactText(""); // Clear the textarea
                toast.success("Data submitted successfully!");
            }
        } catch (error) {
            console.error("Error while submitting fact check data:", error);
            toast.error("Something went wrong while submitting data! Please try again later.");
        } finally {
            // Reset form state and close modal
            setFactText("");
            setIsFactCheckModalOpen(false);
        }
    };

    return (
        <div>
            <button
                className="btn-fill-orange orange-filled-btn"
                onClick={() => setIsFactCheckModalOpen(true)}
            >
                Fact Check
            </button>

            {isFactCheckModalOpen && (
                <div
                    className="modal-backdrop"
                    onClick={() => setIsFactCheckModalOpen(false)} // Close modal on backdrop click
                ></div>
            )}

            {isFactCheckModalOpen && (
                <div
                    className="modal fade show d-block"
                    id="factcheck"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-modal="true"
                >
                    <div className="modal-dialog modal-dialog-centered submit-update">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                >
                                    Fact Check
                                </h1>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() =>
                                        setIsFactCheckModalOpen(false)
                                    }
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p className="m-0 pb-3 please-upload">
                                    Help us maintain accurate and
                                    comprehensive information. If you come
                                    across any details that need review or
                                    investigation, please let us know!
                                </p>
                                <form onSubmit={handleFactCheckSubmit}>
                                    <div className="textarea-fact-check w-100">
                                        <textarea
                                            className="w-100"
                                            value={factText}
                                            onChange={(e) =>
                                                setFactText(e.target.value)
                                            }
                                        ></textarea>
                                    </div>
                                    <div className="text-center mt-4">
                                        <button
                                            type="submit"
                                            className="btn-fill-orange"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}</div>
    )
}

export default FactCheck